import {observer} from 'mobx-react-lite';
import React from 'react';

import {Connector, Step, StepLabel, StyledStepper} from './styles';

export interface Props extends React.HTMLAttributes<HTMLDivElement> {
  labels: string[];
  currentIndex: number;
}

export function StepperComponent({
  labels,
  currentIndex,
  ...props
}: Props): React.ReactElement {
  return (
    <StyledStepper currentIndex={currentIndex} {...props}>
      {labels.map((label, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <React.Fragment key={index}>
          <Step
            data-testid={index === currentIndex ? 'active-step' : undefined}
          >
            <StepLabel>{label}</StepLabel>
          </Step>
          {index === labels.length - 1 ? null : <Connector />}
        </React.Fragment>
      ))}
    </StyledStepper>
  );
}

export default observer(StepperComponent);
